module.exports = __webpack_public_path__ + "img/treatment-diagram-enc-bini.2edf24f2.png";